import { NavLink } from 'react-router-dom';
import { cornBlissLogo } from '../../../data/content';
import { useState, useEffect } from 'react';
import CartWidget from '../../CartWidget';
import './Navbar.css';

function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest('.dropdown-container')) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  const handleNavClick = () => window.scrollTo(0, 0);

  const navItems = [
    { path: '/',            label: 'Home',     icon: '' },
    { path: '/about',       label: 'About Us', icon: '' },
    { path: '/more',        label: 'Products', icon: '' },
    { path: '/contact',     label: 'Contact',  icon: '' },
    // { path: '/admin-login', label: 'Admin',    icon: '' },
  ];

  return (
    <header className={`site-header ${isScrolled ? 'scrolled' : ''}`}>

      {/* ── LEFT: Logo + two-line wordmark ── */}
      <div className="navbar-left">
        <NavLink to="/" className="brand" onClick={handleNavClick}>
          <img src={cornBlissLogo} alt="Corn Bliss logo" className="navbar-logo" />
          <span className="brand-wordmark">
            <span className="brand-wordmark-top">CORN BLISS</span>
            <span className="brand-wordmark-sub">Fresh · Natural · Sri Lanka</span>
          </span>
        </NavLink>
      </div>

      {/* ── CENTER: Desktop nav links ── */}
      <nav className="navbar-center">
        <NavLink to="/" end onClick={handleNavClick}>Home</NavLink>
        <NavLink to="/about" onClick={handleNavClick}>About</NavLink>
        <NavLink to="/more" onClick={handleNavClick}>Products</NavLink>
        <NavLink to="/contact" onClick={handleNavClick}>Contact</NavLink>
        {/* <NavLink to="/admin-login" onClick={handleNavClick}>Admin</NavLink> */}
      </nav>

      {/* ── RIGHT: Cart (desktop) ── */}
      <div className="navbar-right">
        <CartWidget />
      </div>

      {/* ── MOBILE: Cart icon ── */}
      <div className="mobile-cart-widget">
        <CartWidget />
      </div>

      {/* ── MOBILE: Hamburger + Dropdown ── */}
      <div className="dropdown-container">
        <button
          className={`hamburger-toggle ${isDropdownOpen ? 'open' : ''}`}
          onClick={() => setIsDropdownOpen((prev) => !prev)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {isDropdownOpen && (
          <div className="dropdown-menu">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === '/'}
                onClick={() => { setIsDropdownOpen(false); handleNavClick(); }}
                className={({ isActive }) => `dropdown-item${isActive ? ' active' : ''}`}
              >
                <span className="dropdown-icon">{item.icon}</span>
                <span className="dropdown-label">{item.label}</span>
              </NavLink>
            ))}
          </div>
        )}
      </div>

    </header>
  );
}

export default Navbar;